import { ROUTES } from "@routes/RouteConstant";

interface TokenData {
  token: string;
  tokenexpires?: string;
}

interface Header {
  "Content-Type": string;
  "Access-Control-Allow-Origin": string;
  Authorization?: string;
}

export default class RestService {
  rtndata: boolean;
  redirect: string | null;
  body: string | null;
  token: string | null;
  expirytime: string | null;
  timenow: number;
  hasToken: boolean;
  url: string;
  method: string | null;
  data: any;
  header: {
    "Content-Type": string;
    "Access-Control-Allow-Origin"?: string;
    Authorization?: string;
  };

  constructor() {
    this.rtndata = false;
    this.redirect = null;
    this.body = null;
    this.token = null;
    this.expirytime = null;
    this.timenow = Math.round(Date.now() / 1000);
    this.hasToken = false;
    this.url = "";
    this.method = null;
    this.data = null;
    this.header = {
      "Content-Type": "application/json",
    };
  }

  setToken(data: TokenData): this {
    this.token = data.token;
    this.expirytime = data.tokenexpires ?? null;
    return this;
  }

  setHasToken(htoken: boolean): this {
    this.hasToken = htoken;
    return this;
  }

  setUrl(url: string): this {
    this.url = url;
    return this;
  }

  setHeader(header: Header): this {
    this.header = header;
    return this;
  }

  setMethod(method: string): this {
    this.method = method.toUpperCase();
    return this;
  }

  setRedirect(redirect: string): this {
    this.redirect = redirect;
    return this;
  }

  flagReturnData(flag: boolean): this {
    if (typeof flag === "boolean") {
      this.rtndata = flag;
    }
    return this;
  }

  setPostBody(body: any): this {
    this.body = JSON.stringify(body);
    return this;
  }

  async connect(): Promise<this> {
    try {
      if (this.hasToken && this.token) {
        this.header = {
          ...this.header,
          // Authorization: "Bearer " + this.token,
          "Access-Control-Allow-Origin": "*",
        };
      }

      const response = await fetch(this.url, {
        method: this.method!,
        headers: this.header,
        body: this.body,
        credentials: "include",
      });

      const responseStatus = response.status;

      if (responseStatus === 403 || responseStatus === 401) {
        window.location.href = ROUTES.LOGIN;
        return this;
      }

      const data = await response?.json();

      if (this.rtndata) {
        this.data = data;
        return this;
      } else if (data.messageTypeID === 0) {
        throw new Error(data.message);
      }

      if (this.redirect !== null) {
        window.location.href = this.redirect;
      }

      return this;
    } catch (error) {
      console.error("Error in connect:", error);
      throw error;
    }
  }

  getData(): this {
    return this;
  }
}
